// extracted by mini-css-extract-plugin
export default {"component":"-e6GX"};